module.exports = __webpack_public_path__ + "assets/img/ConditionBAIOS.1f69ddcf.png";